import { useState, useEffect, useRef, useContext } from 'react';
import Products from '../Catalog/Products/Products';
import MiniPreloader from '../MiniPreloader/MiniPreloader';
import './FavouritePage.css';
import mainApi from '../../assets/api/MainApi';
import { ConfigContext } from '../../assets/contexts/configContext';

const BATCH_SIZE = 25; // Limit for items per request

function FavouritePage() {
    const config = useContext(ConfigContext)
    const { initialConstants } = config
    const { SHOP_ID_FOR_API, SHOP_NAME, USING_FILTERS } = initialConstants
    const [items, setItems] = useState([]); // Array to store fetched items
    const [offset, setOffset] = useState(0); // Offset for pagination
    const [isMore, setIsMore] = useState(true); // Tracks if more items can be loaded
    const [preloaders, setPreloaders] = useState({ init: true, more: false }); // Preloader states

    const loadMoreRef = useRef(null);

    // Get liked product IDs from local storage
    const likedProductIds = JSON.parse(localStorage.getItem('likedProducts')) || [];

    // Fetch items from API
    const fetchItems = () => {

        const idsToFetch = likedProductIds.slice(offset, offset + BATCH_SIZE);

        setPreloaders((prev) => ({ ...prev, more: true }));

        mainApi
            .getManyItems({
                data: {
                    shop_id: SHOP_ID_FOR_API,
                    ids: idsToFetch,
                },
            })
            .then((res) => {
                setItems((prevItems) => [...prevItems, ...res.data]); // Append new items
                setOffset((prevOffset) => prevOffset + BATCH_SIZE); // Update offset
                setIsMore(likedProductIds.length > offset + BATCH_SIZE); // Check if more items exist
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setPreloaders((prev) => ({ ...prev, init: false, more: false }));
            });
    };

    // Initial fetch on mount
    useEffect(() => {
        console.log("useEffect: fetchItems" + new Date().toISOString())
        const idsToFetch = likedProductIds.slice(0, 0 + BATCH_SIZE);

        if (idsToFetch.length === 0) {
            setIsMore(false); // No more items to load
            setPreloaders((prev) => ({ ...prev, init: false, more: false }));
            return;
        }

        setPreloaders((prev) => ({ ...prev, more: true }));

        mainApi
            .getManyItems({
                data: {
                    shop_id: SHOP_ID_FOR_API,
                    ids: idsToFetch,
                },
            })
            .then((res) => {
                setItems(res.data); // Append new items
                setOffset(BATCH_SIZE); // Update offset
                setIsMore(likedProductIds.length > 0 + BATCH_SIZE); // Check if more items exist
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setPreloaders((prev) => ({ ...prev, init: false, more: false }));
            });
    }, []); // Run only once on component mount

    useEffect(() => {
        // Настраиваем Intersection Observer
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersectin && isMore) {
                    fetchItems();
                }
            },
            { root: null, rootMargin: "0px", threshold: 1.0 }
        );

        if (loadMoreRef.current) {
            observer.observe(loadMoreRef.current);
        }

        return () => {
            if (loadMoreRef.current) {
                observer.unobserve(loadMoreRef.current);
            }
        };
    }, [isMore]);

    return (
        <div className="favourite-page">
            <div className='favourite-page__content'>
                <h2 className="favourite-page__title">Избранное</h2>
                {preloaders.init ? (
                    <div className="favourite-page__preloader">
                        <MiniPreloader />
                    </div>
                ) : (
                    <>
                        <Products
                            items={{ data: items }}
                            preloaders={{
                                items: preloaders.init,
                                subcategories: false,
                            }}
                            category={null}
                            path="/"
                            isSearch
                        />
                        {likedProductIds.slice(offset, offset + BATCH_SIZE).length > 0 ?
                            <button
                                ref={loadMoreRef}
                                className={`favourite-page__more ${preloaders.more ? 'favourite-page__more_loading' : ''}`}
                                type="button"
                                onClick={fetchItems}
                                disabled={preloaders.more}
                            >
                                {preloaders.more ? <MiniPreloader isLinkColor={true} /> : 'Загрузить еще'}
                            </button>
                            : null}
                    </>
                )}
            </div>
        </div>
    );
}

export default FavouritePage;
